"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var transformers_1 = require("../../transformers");

var multitouch_1 = require("../multitouch");

var mouse_1 = require("./mouse");

var getFirstTouch = function getFirstTouch(_a) {
  var firstTouch = _a[0];
  return firstTouch;
};

var pointer = function pointer(props) {
  if (props === void 0) {
    props = {};
  }

  return multitouch_1.getIsTouchDevice() ? multitouch_1.default(props).pipe(function (_a) {
    var touches = _a.touches;
    return touches;
  }, getFirstTouch) : mouse_1.default(props);
};

exports.default = function (_a) {
  if (_a === void 0) {
    _a = {};
  }

  var x = _a.x,
      y = _a.y,
      props = __rest(_a, ["x", "y"]);

  if (x !== undefined || y !== undefined) {
    var applyXOffset_1 = transformers_1.applyOffset(x || 0);
    var applyYOffset_1 = transformers_1.applyOffset(y || 0);
    var delta_1 = {
      x: 0,
      y: 0
    };
    return pointer(props).pipe(function (point) {
      delta_1.x = applyXOffset_1(point.x);
      delta_1.y = applyYOffset_1(point.y);
      return delta_1;
    });
  } else {
    return pointer(props);
  }
};